export class HomeExplorer {
  private element: HTMLElement;
  private details: NodeListOf<HTMLDetailsElement>;
  private accordionContent: HTMLElement | null;

  constructor(element: HTMLElement) {
    if (!!element) {
      this.element = element;
      this.details = this.element.querySelectorAll("details");
      this.accordionContent = this.element.querySelector(
        ".home-explorer__content",
      );
      this.init();
    }
  }

  private init() {
    this.setFirstAsOpen();
    this.handleMenuAccordionsForOlderBrowsers();
  }

  private setFirstAsOpen() {
    this.details.forEach((detail, index) => {
      if (index == 0) {
        detail.open = true;
        if (!CSS.supports("interpolate-size", "allow-keywords")) {
          const firstAccordionContent = detail.querySelector(
            ".home-explorer__content",
          );
          firstAccordionContent?.classList.add("home-accordion__content--open");
        }
      }
    });
  }

  private handleMenuAccordionsForOlderBrowsers() {
    // Code for browsers that don't support interpolate-size
    if (!CSS.supports("interpolate-size", "allow-keywords")) {
      this.details?.forEach((accordion) => {
        const accordionContent = accordion.querySelector(
          ".home-explorer__content",
        );
        accordion.addEventListener("click", (e) => {
          const target = e.target as HTMLElement;
          const summary = accordion.querySelector("summary");

          // Only toggle if clicking on the summary element or its children (not content area)
          if (!summary?.contains(target)) {
            return;
          }

          accordionContent?.classList.add("home-accordion__content--open");
          if (accordion.hasAttribute("open") && accordionContent) {
            e.preventDefault();
            accordionContent?.classList.remove("home-accordion__content--open");
            setTimeout(() => {
              accordion.removeAttribute("open");
            }, 300);
          }
        });
      });
    }
  }
}

export default function homeExplorerInit() {
  const homeExplorer = document.querySelector(".home-explorer") as HTMLElement;

  new HomeExplorer(homeExplorer);
}
